import { useState } from 'react'
import { HOME_PRODUCT_KEYS, SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'

/** @param {ReturnType<typeof import('@/features/chat/chatPersist').loadChatPersist>} persisted */
export function useChatUiSlices(persisted) {
  const [homeProduct, setHomeProduct] = useState(
    persisted?.homeProduct ?? HOME_PRODUCT_KEYS.CHAT,
  )
  const [homeView, setHomeView] = useState(persisted?.homeView ?? SECONDARY_VIEW_KEYS.HOME_MAIN)
  const [selectedThreadId, setSelectedThreadId] = useState(persisted?.selectedThreadId ?? null)
  const [activeQueryVersionByExchangeId, setActiveQueryVersionByExchangeId] = useState(
    persisted?.activeQueryVersionByExchangeId ?? {},
  )
  const [activeAnswerVersionByExchangeId, setActiveAnswerVersionByExchangeId] = useState(
    persisted?.activeAnswerVersionByExchangeId ?? {},
  )
  const [mainAskBarPrefill, setMainAskBarPrefill] = useState(null)

  return {
    homeProduct,
    setHomeProduct,
    homeView,
    setHomeView,
    selectedThreadId,
    setSelectedThreadId,
    activeQueryVersionByExchangeId,
    setActiveQueryVersionByExchangeId,
    activeAnswerVersionByExchangeId,
    setActiveAnswerVersionByExchangeId,
    mainAskBarPrefill,
    setMainAskBarPrefill,
  }
}
